// extracted by mini-css-extract-plugin
export default {"root":"m3c7FDf_zhabZzjVuq5e","link":"QH4J4TXXP5NlZEvrcyD1","active":"aMMWa3L0PcFvMbebdvhR","disabled":"uheH6bbFzNOWnlPgGBSg","placeHolderShimmer":"nXqDk5pAPfPSYfW8UEuL"};